<template>
  <canvas :id="name"></canvas>
</template>

<script>
import Chart from 'chart.js';
import { debounce } from 'lodash';

export default {
  name: 'NmtSidebarProfileChart',
  props: {
    name: {
      type: String,
      default: 'chartNmt',
    },
    heights: {
      type: Array,
      required: true,
    },
    length: {
      type: String,
      required: true,
    },
    interval: {
      type: Number,
      required: true,
    },
  },
  watch: {
    heights() {
      this.init();
    },
  },
  methods: {
    getData() {
      const lastIndex = this.heights.length - 1;
      return this.heights.map((height, index) =>
        index === lastIndex ? { y: height, x: this.length } : { y: height, x: index * this.interval }
      );
    },
    drawChart(data) {
      const canvas = document.getElementById(this.name);
      this.chart = new Chart(canvas, {
        data: {
          datasets: [
            {
              showLine: true,
              label: `- ${this.$i18n.t('sidebar.nmtHeight')} [m ${this.$i18n.t('sidebar.nmtAboveSeaLevelAbbr')}]`,
              data,
              fill: false,
              borderColor: this.$_colors.primary,
              borderWidth: 1,
            },
          ],
        },
        type: 'scatter',
        options: {
          maintainAspectRatio: true,
          responsive: true,
          title: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: `[m ${this.$i18n.t('sidebar.nmtAboveSeaLevelAbbr')}]`,
                },
              },
            ],
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: '[m]',
                },
              },
            ],
          },
          events: ['mousemove'],
          onHover: debounce((e, chartElement) => {
            if (chartElement.length === 0) {
              this.$root.$emit('removeMarker');
              return;
            }
            const [element] = chartElement;
            const fraction = element._index / (data.length - 1);
            this.$emit('drawMarker', fraction);
          }, 50),
        },
      });
    },
    init() {
      this.drawChart(this.getData());
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped></style>
